import { Col, Row } from 'antd';
import Image from 'next/image';
import styled from 'styled-components';

import JensImage from '../assets/images/LandingPage/jens.png';
import theme from '../assets/theme';
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import { ResponsiveSectionContainer } from '../components/styled/ResponsiveSection';
import { useIsMobile } from '../hooks/useIsMobile';

const ContactUsPage = () => {
  const isMobile = useIsMobile();
  return (
    <LandingPageLayout>
      <ResponsiveSectionContainer
        isMobile={isMobile}
        style={{ background: theme.colors.background, flex: 1 }}
      >
        <Overlay color={theme.colors.background} />
        <Row
          style={{
            zIndex: 2,
            paddingTop: 60,
            paddingBottom: 20,
            height: '100%',
            flex: 1,
          }}
        >
          <Col xs={24} md={24} lg={24} xl={24}>
            <Container>
              <InformationContainer>
                <h1>I would love to hear from you</h1>
                <ProfileImage
                  src={JensImage}
                  alt="Co-founder & CEO"
                  width={'300px'}
                  height={'300px'}
                />
                <p style={{ marginTop: '10px' }}>
                  Hey! I am the CEO of Curipod. Whether you have a question about
                  features, pricing, need a demo or anything else, I am here to help you
                  out.
                </p>
                <a
                  style={{
                    fontSize: 18,
                    display: 'block',
                    margin: 10,
                    textDecoration: 'underline',
                  }}
                  href={`https://share.hsforms.com/1Nwgx-5qBT_euEVjxG-eztw4evga`}
                  target="__blank"
                  rel="noopener noreferrer"
                >
                  To request a data privacy agreement click here
                </a>
                <span style={{ fontSize: 18 }}>
                  Send me an email at:{' '}
                  <a color="blue" href="mailto: jens@curipod.com">
                    <span style={{ color: 'blue' }}>jens@curipod.com</span>
                  </a>
                </span>
              </InformationContainer>
            </Container>
          </Col>
        </Row>
      </ResponsiveSectionContainer>
    </LandingPageLayout>
  );
};

const ProfileImage = styled(Image)`
  max-height: 300px;
  max-width: 300px;
  border-radius: 20px;
  object-fit: cover;
`;
const InformationContainer = styled.div`
  text-align: center;
  margin-bottom: 30px;
  width: 540px;

  h1 {
    font-size: 40px;
    margin-bottom: 40px;
    width: 100%;
  }

  h4 {
    font-weight: bold;
    width: 100%;
  }

  p {
    font-size: 22px;
    margin-bottom: 60px;
    line-height: 30px;
    width: 100%;
  }

  @media ${theme.device.mobileL} {
    width: 300px;
    padding: 20px;
    h1 {
      font-size: 24px;
    }
    h4 {
      font-size: 16px;
    }
    p {
      font-size: 14px;
    }
  }
`;

const FullSizeOverLay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* z-index: 0; */
  height: 100%;
  width: 100%;
`;

const Overlay = styled(FullSizeOverLay)<{ color: string }>`
  /* z-index: 1; */
  background-color: ${({ color }) => color};
  opacity: 0.7;
`;

const Container = styled.div`
  height: 100%;
  min-height: 750px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default ContactUsPage;
